import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isEmpty } from '../../../utils/transformValueUtils';
import FieldWithLabelAndValue from './atomic/FieldWithLabelAndValue';
import { HIGHLIGHT_PHONE } from '../../../constants/dataTestIds';
import { jsx as _jsx } from "react/jsx-runtime";
const Phone = ({
  value
}) => {
  const link = isEmpty(value) ? ` ${value}` : /*#__PURE__*/_jsx(UILink, {
    href: `tel:${value.replaceAll(/[^+\d]/gi, '')}`,
    children: ` ${value}`
  });
  return /*#__PURE__*/_jsx(FieldWithLabelAndValue, {
    "data-test-id": HIGHLIGHT_PHONE,
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "highlightCard.propertyLabels.phone"
    }),
    value: link
  });
};
export default Phone;